// @ts-check
import React, { useEffect, useState } from "react";

import Share from "./Share";
import Upload from "./Uploadfile";

import { getContactList } from "../../../Class/contacts";

import Iconos from "../ClasesFunsiones/Iconos";

import "./Dialog.scss";
import { X } from "lucide-react";
import StudyItem from "../../../Class/study";
import { shareWhatsapp } from "../../../utils/shareWhatsapp";
import { useMainContext } from "../MainContext";

/**
 * @returns {JSX.Element | null}
 */
function Dialog() {
  const { state } = useMainContext();
  const visible = state.ui.dialog.visible;

  if (!visible) return null;

  return (
    <div id="DialogN" className="activo">
      <Velo />
      <Box />
    </div>
  );
}

export default Dialog;

/**
 * @returns {JSX.Element}
 */
const Velo = () => {
  const { dispatch } = useMainContext();
  const onClose = () => dispatch({ type: 'SET_DIALOG', payload: { visible: false, componente: 0 } });
  return <div className="Velo activo" onClick={onClose}></div>;
};

/**
 * @returns {JSX.Element}
 */
const Box = () => {
  const { state, dispatch } = useMainContext();
  const activo = state.ui.dialog;
  const paciente = state.ui.herramientas;
  const onClose = () => dispatch({ type: 'SET_DIALOG', payload: { visible: false, componente: 0 } });
  
  let COMP;
  switch (activo.componente) {
    case 0:
      COMP = <Share activo={activo} paciente={paciente} CerrarDialog={onClose} />;
      break;
    case 1:
      COMP = <Upload activo={activo} paciente={paciente} CerrarDialog={onClose} />;
      break;
    case 2:
      COMP = <Agenda />;
      break;
    default:
      COMP = <Share activo={activo} paciente={paciente} CerrarDialog={onClose} />;
      break;
  }
  return (
    <div className="Box">
      <div className="CloseDialog" onClick={onClose}>
        <X />
      </div>
      <div className="Contenido">{COMP}</div>
    </div>
  );
};

/**
 * @returns {JSX.Element}
 */
const Agenda = () => {
  const [Contactos, setContactos] = useState({ listo: false, lista: [] });

  useEffect(() => {
    getContactList().then((res) => {
      //console.log(res)
      setContactos({ listo: true, lista: res });
    });
  }, []);
  if (!Contactos.listo) {
    return <div className="Agenda cargandoAgenda">Cargando agenda...</div>;
  }
  return (
    <div className="Agenda">
      {Contactos.lista.map((contacto, index) => (
        <TarjetaContacto key={index} contacto={contacto} />
      ))}
    </div>
  );
};
/**
 * @param {Object} props
 * @param {any} props.contacto
 * @returns {JSX.Element}
 */
const TarjetaContacto = (props) => {
  const { state } = useMainContext();
  const paciente = state.ui.herramientas;
  console.log(props);
  
  let compartirWP = () => {
    if (!paciente) return;
    shareWhatsapp(props.contacto.phone, {
      nombre: paciente.nombre,
      link: paciente.link,
      token: paciente.token,
    });
  };
  return (
    <div className="TarjetaContacto">
      <div className="TarjetaContacto1">
        <div className="TarjetaContacto11">{props.contacto.nombre}</div>
        <div className="TarjetaContacto12">{props.contacto.area}</div>
      </div>
      <div className="TarjetaContacto2">
        <ShareM onClick={compartirWP} icon="WP" />
      </div>
    </div>
  );
};

/**
 * @param {any} props
 */
const ShareM = (props) => {
  return (
    <div className="ShareM" onClick={props.onClick}>
      <Iconos icon={props.icon} />
    </div>
  );
};
